export const COMPUTING_OPACITY_PULSE_CLASS = "motion-safe:animate-pulse";
